import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Hub } from 'aws-amplify'
import { completeSignIn, handleSignedOut, restoreSession, selectAuthStatus } from './authSlice'

const useAuthSession = () => {
    const dispatch = useDispatch()
    const status = useSelector(selectAuthStatus)

    useEffect(() => {
        const stopListening = Hub.listen('auth', ({ payload: { event } }) => {
            if (event === 'signIn') {
                dispatch(completeSignIn())
            } else if (event === 'signOut') {
                window.localStorage.clear()
                dispatch(handleSignedOut())
            }
        })
        dispatch(restoreSession())
        return stopListening
    }, [dispatch])

    return status
}

export default useAuthSession
